export class ConfigProps {
    static VISUAL_CHECK_PER_CELL_W = "visualCheckPerCell"
    static CORE_DATA_CHECK_PER_CELL_W = "coreDataCheckPerCell"
    static FULL_CHECK_PER_CELL_W = "fullCheckPerCell"
    static REGULAR_UPDATE_PER_CELL_W = "regularUpdatePerCell"
    static MISTAKES_DETECTION_UPDATE_PER_CELL_W = "mistalesDetectionPerCell"
    static KPI_PER_CELL_W = "kpiPerCell"
    static IS_PER_CELL_W = "isPerCell"
    static OTHER_PER_CELL_W = "otherPerCell"
    static TABLE_TYPES = "tableTypes"

    static T_MISTAKES_FOR_R_UPDATE = "maxMistakesForReqularUpdate"
    static T_MISTAKES_FOR_F_C_REVIEW = "maxMistakesForFullCheckReview"
    static T_MISTAKES_FOR_C_D_C_REVIEW = "maxMistakesForCoreDataCheckReview"
}

export const DEFAULT_CONFIG = {
    [ConfigProps.VISUAL_CHECK_PER_CELL_W]: 0.18,
    [ConfigProps.CORE_DATA_CHECK_PER_CELL_W]: 0.37,
    [ConfigProps.FULL_CHECK_PER_CELL_W]: 0.72,
    [ConfigProps.REGULAR_UPDATE_PER_CELL_W]: 1,
    [ConfigProps.MISTAKES_DETECTION_UPDATE_PER_CELL_W]: 0.9,
    [ConfigProps.KPI_PER_CELL_W]: 1.7,
    [ConfigProps.IS_PER_CELL_W]: 1,
    [ConfigProps.OTHER_PER_CELL_W]: 1,

    [ConfigProps.T_MISTAKES_FOR_R_UPDATE]: 1.31,
    [ConfigProps.T_MISTAKES_FOR_F_C_REVIEW]: 1.02,
    [ConfigProps.T_MISTAKES_FOR_C_D_C_REVIEW]: 0.64,

    [ConfigProps.TABLE_TYPES]: []
}

/**
 * Based on weights on (Sept. 2024) we assume that 1 updated cell is equal to 0.2244 verified in a core data review
 */
export const CORE_DATA_REVIEW_WEIGHT = 0.2244;